// src/utils/courseUtils.js

const normalizePercent = value => {
	const parsed = Number(value)
	if (!Number.isFinite(parsed)) return 0
	return Math.max(0, Math.min(100, parsed))
}

/**
 * Конфигурация демо-преподавателей
 */
export const DEMO_TEACHERS = {
	'Магомедов Ислам Тагирович': {
		avatar:
			'/assets/animaapp/molodoi-muzcina-derzit-papku-v-beloi-rubaske-stanah-i-vygladit-k@2x.png',
		isDemo: true,
	},
}

/**
 * Проверка видимости курса
 * @param {Object} course - объект курса
 * @returns {boolean}
 */
export function isVisibleCourse(course) {
	if (
		typeof course.is_hidden === 'undefined' &&
		typeof course.is_published === 'undefined'
	) {
		return true
	}
	return !course.is_hidden && course.is_published
}

/**
 * Нормализация данных записи на курс
 * @param {Object} enrollment - объект записи
 * @returns {Object} - нормализованный объект
 */
export function normalizeEnrollment(enrollment) {
	const course = enrollment.course || enrollment
	return {
		id: enrollment.id,
		courseId: enrollment.course_id || course.id,
		title: course.title,
		coverImage: course.cover_image_url || '',
		progressPercent: normalizePercent(
			enrollment.progress_percent ?? enrollment.progress ?? 0
		),
		currentLesson:
			enrollment.current_lesson_number ?? enrollment.current_lesson ?? 0,
		totalLessons: enrollment.total_lessons ?? enrollment.lessons_total ?? 0,
	}
}

/**
 * Форматирование длительности в минутах
 * @param {number} mins - минуты
 * @returns {string}
 */
export function formatDuration(mins) {
	const m = Number(mins) || 0
	const h = Math.floor(m / 60)
	const mm = Math.floor(m % 60)
	return `${h}ч ${mm}мин`
}

/**
 * Склонение слова "модуль"
 * @param {number} val - количество
 * @returns {string}
 */
export function moduleWord(val) {
	const n = Number(val) || 0
	const mod10 = n % 10
	const mod100 = n % 100

	if (mod10 === 1 && mod100 !== 11) return 'модуль'
	if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'модуля'
	return 'модулей'
}

/**
 * Форматирование рейтинга
 * @param {number|string} val - значение рейтинга
 * @returns {string}
 */
export function formatRating(val) {
	const n = Number(String(val ?? '').replace(',', '.')) || 0
	return n.toLocaleString('ru-RU', {
		minimumFractionDigits: 1,
		maximumFractionDigits: 1,
	})
}

/**
 * Получение инициалов из имени
 * @param {string} name - полное имя
 * @returns {string}
 */
export function getInitials(name) {
	if (!name) return '?'
	return name
		.split(' ')
		.map(n => n[0])
		.join('')
		.toUpperCase()
		.slice(0, 2)
}
